module.exports = __webpack_public_path__ + "assets/1465ede0880086a302b7f13416ee2156.mp3";